import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyMoreMenu = loadable(
  () =>
    import(
      /* webpackChunkName: "content/admin/travel-map/more-menu" */
      './MoreMenu'
    ),
  'MoreMenu',
);
